/**
 * Product Accessories Presenter
 */
class ProductAccessoriesPresenter {

	constructor(sectionId, recommendationsUrl, productId) {

		this.view = new ProductAccessoriesView(this, sectionId);

		/*
		 * Listeners
		 */

		$(document).on(Model.LOCAL_STORAGE_AVAILABLE, $.proxy(function(_event) {
			// local storage is available, so request any product handles are retrieved and update the view
			$(document).trigger(Model.LOCAL_STORAGE_RETRIEVE_PRODUCT_HANDLES);
			this.view.setLocalStorageAvailable();
		}, this));

		$(document).on(Model.LOCAL_STORAGE_PRODUCT_HANDLES_RETRIEVED, $.proxy(function(_event, handles) {
			// process the retrieved handles
			this.view.setWishlistProductHandles(handles);
		}, this));

		$(document).on(Model.RELATED_PRODUCTS_RETRIEVED, $.proxy(function(_event, html, forProductId) {
			if (html == null || forProductId != productId) { return; }
			this.view.setRelatedProducts(html);
		}, this));

		/*
		 * Initialisation
		 */

		$(document).trigger(Model.RETRIEVE_RELATED_PRODUCTS, [recommendationsUrl, "recommendations-data-section", productId, 10]);

	}	

	/*
	 * Actions
	 */

	wishlistAdd(handle) {
		$(document).trigger(Model.LOCAL_STORAGE_ADD_PRODUCT_HANDLE, [handle, function() {
			// the product handle has been added to the wishlist, so redirect to the product page
			window.location.href = "/pages/wishlist";
		}]);
	}

	updateCart(formData) {
		$(document).trigger(Model.UPDATE_CART, [formData, $.proxy(function() {
			// the cart has been updated, so reset the view
			this.view.resetForm();
		}, this)]);
	}

	/*
	 * Getters and Setters
	 */

}